import FaqIcon from '@/assets/icons/faq-icon.svg'
import HelpMessage from '@/assets/icons/help-otherSection.svg'
import Search from '@/assets/icons/search-button.svg'

import { ROUTES } from '@/core/constants/routes'
import { NavLink } from '@/core/ui/atoms/nav-link'
import { getTranslations } from 'next-intl/server'

type Props = { className?: string }

export const HelpSidebar: React.FC<Props> = async ({ className = '' }) => {
  const t = await getTranslations()
  return (
    <aside className={`${className}`}>
      <h3 className='mb-8 text-3xl font-medium'>{t('links.help')}</h3>
      <div className='relative mb-5 hidden w-full'>
        <input
          type='search'
          placeholder='Search...'
          className='caret-primary w-full min-w-60 rounded-md border-2 border-solid px-4 py-3 focus:outline-none sm:min-w-0'
        />
        <Search className='absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer' />
      </div>
      <ul>
        <li>
          <NavLink
            href={ROUTES.helpCenter}
            className={{
              active: 'bg-pale-blue-alt block',
              main: 'mb-4 block cursor-pointer rounded-md p-4',
            }}
          >
            <div className='flex items-center'>
              <HelpMessage className='mt-1' />
              <p className='ms-3'>{t('links.helpCenter')}</p>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink
            href={ROUTES.helpFaq}
            className={{
              active: 'bg-pale-blue-alt block',
              main: 'mb-4 block cursor-pointer rounded-md p-4',
            }}
          >
            <div className='flex items-center'>
              <FaqIcon className='mt-1' />
              <p className='ms-3'>{t('links.faq')}</p>
            </div>
          </NavLink>
        </li>
      </ul>
    </aside>
  )
}
